<template>
  <div>
    <a-row :gutter="48">
      <a-col :span="24">
        <div style="float: right;margin-bottom: 10px;margin-right: 20px;">
          <a-button
            icon="plus"
            @click="$refs.modal.handleOpen()"
          >手动添加云卡</a-button>
        </div>
      </a-col>
    </a-row>
    <a-row :gutter="48">
      <a-col :span="24">
        <div style="width: 100%;display: -webkit-box;margin-right:20px">
          <a-row
            :gutter="16"
            style="width: 100%;"
            v-if="loadData.length >0"
          >
            <a-col
              :xl="8"
              :lg="12"
              :md="12"
              :sm="24"
              :xs="24"
              v-for="(item,index) in loadData"
              :key="index"
              :style="{paddingLeft: '0px', paddingRight:'0px',paddingBottom:'20px'}"
            >
              <a-card
                hoverable
                :bordered="false"
                style="height:500px;box-shadow: rgb(170, 170, 170) 1px 1px 15px;margin-right: 10px;"
                :bodyStyle="{padding:'5px 24px'}"
              >
                <template slot="cover">
                  <img
                    alt="example"
                    src="https://yunxuegu-2019.oss-cn-hangzhou.aliyuncs.com/EnglishData/CloudCard/%E4%BA%91%E5%8D%A1%E5%B0%8F%E5%AD%A6.png"
                    v-if="item.cardSection==='1'"
                  />
                  <img
                    alt="example"
                    src="https://yunxuegu-2019.oss-cn-hangzhou.aliyuncs.com/EnglishData/CloudCard/%E4%BA%91%E5%8D%A1%E5%88%9D%E4%B8%AD.png"
                    v-if="item.cardSection==='2'"
                  />
                  <img
                    alt="example"
                    src="https://yunxuegu-2019.oss-cn-hangzhou.aliyuncs.com/EnglishData/CloudCard/%E4%BA%91%E5%8D%A1%E9%AB%98%E4%B8%AD.png"
                    v-if="item.cardSection==='3'"
                  />
                  <span
                    v-if="item.cardType ==='0'"
                    class="sidai"
                  >体验卡</span>
                  <span
                    v-if="item.cardType ==='1'"
                    class="sidai2"
                  >正式卡</span>
                </template>
                <div
                  style=" margin-bottom: 10px;background-color: #ffc10752;cursor:pointer;"
                  v-if="item.cardType ==='0'"
                  @click="onUpgrade"
                >
                  <span style="color: #FF5722;padding: 5px;">
                    <span style="font-size: 20px;">
                      <a-icon type="shopping-cart" /></span>
                    点击购买云卡，解锁所有资源</span>
                </div>
                <div style="margin-bottom: 10px;">
                  有效期限：
                  <span v-if="item.cardType ==='0'">
                    {{ item.overTime }}
                  </span>
                  <span v-else>
                    {{ item.overDate }}
                  </span>
                  <a-button
                    v-if="item.codeState ==='0'"
                    size="small"
                    style="float: right;background-color: red;color: white;"
                    @click="renewChange"
                  >过期续费</a-button>
                  <a-tag
                    v-if="item.delFlag ==='1'"
                    style="background-color:red;color: white;"
                  >禁用</a-tag>
                </div>
                <a-card-meta>
                  <template slot="title">
                    <span>当前卡片资源内容: ({{ item.pressName }}</span>
                    <span v-if="item.cardSection==='1'">{{ item.originType| typeFilter }})</span>
                    <span v-else>)</span>
                  </template>
                  <template
                    v-if="(item.codeState ==='0' || item.delFlag ==='1') || (item.codeState ==='0' && item.delFlag ==='1')"
                    slot="description"
                  >
                    <a-radio-group
                      style="margin-bottom: 10px;"
                      buttonStyle="solid"
                      v-if="item.cardSection==='1' && item.originType==='1'"
                      v-model="item.classYear"
                      :disabled="true"
                    >
                      <a-radio-button value="1">一年级</a-radio-button>
                      <a-radio-button value="2">二年级</a-radio-button>
                      <a-radio-button value="3">三年级</a-radio-button>
                    </a-radio-group>
                    <a-radio-group
                      style="margin-bottom: 10px;"
                      buttonStyle="solid"
                      v-if="item.cardSection==='1' && item.originType==='2'"
                      v-model="item.classYear"
                      :disabled="true"
                    >
                      <a-radio-button value="3">三年级</a-radio-button>
                      <a-radio-button value="4">四年级</a-radio-button>
                      <a-radio-button value="5">五年级</a-radio-button>
                    </a-radio-group>
                    <a-radio-group
                      buttonStyle="solid"
                      v-if="item.cardSection==='1' && item.originType==='1'"
                      v-model="item.classYear"
                      :disabled="true"
                    >
                      <a-radio-button value="4">四年级</a-radio-button>
                      <a-radio-button value="5">五年级</a-radio-button>
                      <a-radio-button value="6">六年级</a-radio-button>
                    </a-radio-group>
                    <a-radio-group
                      buttonStyle="solid"
                      v-if="item.cardSection==='1' && item.originType==='2'"
                      v-model="item.classYear"
                      :disabled="true"
                    >
                      <a-radio-button value="6">六年级</a-radio-button>
                    </a-radio-group>
                    <a-radio-group
                      buttonStyle="solid"
                      v-if="item.cardSection==='2'"
                      v-model="item.classYear"
                      :disabled="true"
                    >
                      <a-radio-button value="7">七年级</a-radio-button>
                      <a-radio-button value="8">八年级</a-radio-button>
                      <a-radio-button value="9">九年级</a-radio-button>
                    </a-radio-group>
                    <a-radio-group
                      buttonStyle="solid"
                      v-if="item.cardSection==='3'"
                      v-model="item.classYear"
                      :disabled="true"
                    >
                      <a-radio-button value="10">高一</a-radio-button>
                      <a-radio-button value="11">高二</a-radio-button>
                      <a-radio-button value="12">高三</a-radio-button>
                    </a-radio-group>
                  </template>
                  <template
                    v-else
                    slot="description"
                  >
                    <a-radio-group
                      style="margin-bottom: 10px;"
                      buttonStyle="solid"
                      v-if="item.cardSection==='1' && item.originType==='1'"
                      v-model="item.classYear"
                      @change="onChange(item)"
                    >
                      <a-radio-button value="1">一年级</a-radio-button>
                      <a-radio-button value="2">二年级</a-radio-button>
                      <a-radio-button value="3">三年级</a-radio-button>
                    </a-radio-group>
                    <a-radio-group
                      style="margin-bottom: 10px;"
                      buttonStyle="solid"
                      v-if="item.cardSection==='1' && item.originType==='2'"
                      v-model="item.classYear"
                      @change="onChange(item)"
                    >
                      <a-radio-button value="3">三年级</a-radio-button>
                      <a-radio-button value="4">四年级</a-radio-button>
                      <a-radio-button value="5">五年级</a-radio-button>
                    </a-radio-group>
                    <a-radio-group
                      buttonStyle="solid"
                      v-if="item.cardSection==='1' && item.originType==='1'"
                      v-model="item.classYear"
                      @change="onChange(item)"
                    >
                      <a-radio-button value="4">四年级</a-radio-button>
                      <a-radio-button value="5">五年级</a-radio-button>
                      <a-radio-button value="6">六年级</a-radio-button>
                    </a-radio-group>
                    <a-radio-group
                      buttonStyle="solid"
                      v-if="item.cardSection==='1' && item.originType==='2'"
                      v-model="item.classYear"
                      @change="onChange(item)"
                    >
                      <a-radio-button value="6">六年级</a-radio-button>
                    </a-radio-group>
                    <a-radio-group
                      buttonStyle="solid"
                      v-if="item.cardSection==='2'"
                      v-model="item.classYear"
                      @change="onChange(item)"
                    >
                      <a-radio-button value="7">七年级</a-radio-button>
                      <a-radio-button value="8">八年级</a-radio-button>
                      <a-radio-button value="9">九年级</a-radio-button>
                    </a-radio-group>
                    <a-radio-group
                      buttonStyle="solid"
                      v-if="item.cardSection==='3'"
                      v-model="item.classYear"
                      @change="onChange(item)"
                    >
                      <a-radio-button value="10">高一</a-radio-button>
                      <a-radio-button value="11">高二</a-radio-button>
                      <a-radio-button value="12">高三</a-radio-button>
                    </a-radio-group>
                  </template>

                </a-card-meta>
              </a-card>
            </a-col>
          </a-row>
          <a-row
            :gutter="16"
            style="width: 100%;text-align: center;"
            v-else
          >
            暂无体验卡</a-row>
        </div>
      </a-col>
    </a-row>
    <addCard-modal ref="modal"></addCard-modal>
  </div>
</template>
<script>

import { getCardList } from '@/api/account/mycloudcard'
import { putObj } from '@/api/datum/student'
import AddCardModal from './modules/AddCardModal'
import { mapGetters } from 'vuex'
export default {
  name: 'MyCloudCard',
  computed: {
    ...mapGetters(['userInfo'])
  },
  components: {
    AddCardModal
  },
  data () {
    return {
      defaultValue: '',
      loadData: [],
      queryParam: {},
      codeForm: {}
    }
  },
  mounted () {
    this.value = this.userInfo.classYear
    this.defaultValue = this.userInfo.classYear
  },
  created () {
    // console.log('userInfo:' + JSON.stringify(this.userInfo))
    this.handelData()
  },
  filters: {
    typeFilter (value) {
      const typeMap = {
        1: '/一起点',
        2: '/三起点'
      }
      return typeMap[value]
    }
  },
  methods: {
    handelData () {
      this.queryParam = {}
      // 判断当前用户是否未VIP（当用户购买云卡，极为VIP，）
      // if (this.userInfo.vipType === '1') {
      //   this.queryParam.codeState = '0'
      // }
      getCardList(this.queryParam).then(res => {
        // console.log('我的云卡:' + JSON.stringify(res.result))
        res.result.forEach((item, i) => {
          if (this.userInfo.stuSection === '1') {
            if (this.userInfo.stuPress === item.press && this.userInfo.originType === item.originType) {
              item.classYear = this.userInfo.classYear
            }
          } else {
            if (this.userInfo.stuPress === item.press) {
              item.classYear = this.userInfo.classYear
            }
          }
        })
        this.loadData = res.result
      })
    },
    onChange (e) {
      this.codeForm = e
      this.$confirm({
        title: '确认切换自学内容与预测分?',
        okText: '确定',
        cancelText: '取消',
        okButtonProps: {
          on: {
            click: this.clickHandler
          }
        },
        cancelButtonProps: {
          on: {
            click: this.cancelHandler
          }
        }
      })
    },
    clickHandler (e) {
      // console.log('我的云卡:' + JSON.stringify(this.codeForm))
      this.defaultValue = this.codeForm.classYear
      this.userInfo.classYear = this.codeForm.classYear
      this.userInfo.stuPress = this.codeForm.press
      this.userInfo.originType = this.codeForm.originType
      this.userInfo.stuSection = this.codeForm.cardSection
      this.queryParam = {}
      this.queryParam.stuSection = this.codeForm.cardSection
      this.queryParam.classYear = this.codeForm.classYear
      this.queryParam.stuPress = this.codeForm.press
      this.queryParam.originType = this.codeForm.originType
      // this.queryParam.cardNum = this.codeForm.cardNum
      putObj(this.queryParam).then(res => {
        this.$message.success('切换年级成功！')
      }).catch(() => {
        this.$message.error('切换年级失败！')
      }).finally(() => {
        this.$router.push({ path: '/dashboard/workplace' })
      })
    },
    cancelHandler () {
      const data = this.loadData.filter(item => item.id === this.codeForm.id)[0]
      // data.classYear = this.defaultValue
      // this.userInfo.classYear = this.defaultValue
      if (data.press === this.userInfo.stuPress && this.userInfo.originType === data.originType) {
        data.classYear = this.defaultValue
        this.userInfo.classYear = this.defaultValue
      } else {
        data.classYear = ''
      }
    },
    // 升级
    onUpgrade () {
      this.$router.push({ path: '/cloudCard' })
    },
    renewChange () {
      this.$message.info('续费功能暂未开通！')
    }
  }
}
</script>
<style >
.sidai {
  display: inline-block;
  text-align: center;
  width: 75px;
  line-height: 30px;
  position: absolute;
  top: 135px;
  right: 10px;
  background: #ff5722;
  color: white;
  border-radius: 5px;
}
.sidai2 {
  display: inline-block;
  text-align: center;
  width: 75px;
  line-height: 30px;
  position: absolute;
  top: 135px;
  right: 10px;
  background: #57dd43;
  color: white;
  border-radius: 5px;
}
.sidai1 {
  display: inline-block;
  text-align: center;
  width: 75px;
  line-height: 30px;
  position: absolute;
  top: 135px;
  right: 10px;
  background: red;
  color: white;
  border-radius: 5px;
}
</style>
